import './ajax-loading-indicator.scss';



// WEBPACK FOOTER //
// ./resources/modules/products/v2_0/shared/AjaxLoadingIndicator/index.js